export default {
    methods: {
        buildTermPageURI (base, terms, page){
            var uri = [base];
            var tail = [];
            if (page != null) {
                tail.push('page=' + page);
            }
            if (terms != null) {
                for (var term of terms) {
                    tail.push('terms[]=' + term);
                }
            }
            uri.push(tail.join('&'));
            return uri.join('?');
        }
    }
}
